import Alpine from 'alpinejs'
import htmx from 'htmx.org'

htmx.config.includeIndicatorStyles = false;
// Work against 'unsafe-inline' CSP.
htmx.config.includeIndicatorStyles = false;
// Work against 'unsafe-eval' CSP.
htmx.config.selfRequestsOnly = true;
htmx.config.allowScriptTags = false;
htmx.config.allowEval = false;

globalThis.Alpine = Alpine
globalThis.htmx = htmx

// Manages the loading state of the fetch form in response to htmx lifecycle events.
Alpine.data('fetchForm', () => ({
  loading: false,
  init() {
    this.$el.addEventListener('htmx:beforeRequest', () => { this.loading = true })
    this.$el.addEventListener('htmx:afterRequest',  () => { this.loading = false })
  },
}))

Alpine.start()
